import { Component, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { DeviceType } from '@era/locations-sdk';

import { AsyncPipe } from '@angular/common';
import { DeviceStoreSelectors } from '@era/stores';
import { Device, DeviceActionBarComponent } from '@rocksoft/shared';
import { AppleDeviceContainerComponent } from '../../components/apple-device/apple-device.container';

@Component({
  selector: 'era-devices-in-room',
  templateUrl: './devices-in-room.container.html',
  imports: [AppleDeviceContainerComponent, DeviceActionBarComponent, AsyncPipe],
})
export class DevicesInRoomContainerComponent {
  private readonly store = inject(Store);
  public readonly device$: Observable<Device[]>;

  constructor() {
    this.device$ = this.store
      .select(DeviceStoreSelectors.selectDevicesForCurrentRoom)
      .pipe(map((x) => x.filter((y) => y.deviceType === DeviceType.Apple)));
  }
}
